import { render, staticRenderFns } from "./ModalSelectHorse.vue?vue&type=template&id=2e5f0e00&"
import script from "./ModalSelectHorse.vue?vue&type=script&lang=js&"
export * from "./ModalSelectHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports